import { DataService } from 'app/shared/services/data/data.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileHandle } from 'app/shared/directives/drag-drop-file-offer.directive';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferFileService } from 'app/shared/services/offer-file/offer-file.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialogConfirmComponent } from 'app/components/dialog/open-dialog-confirm/open-dialog-confirm.component';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ExternalLinkFormComponent } from './external-link-form/external-link-form.component';

@Component({
  selector: 'app-admin-offer-file',
  templateUrl: './admin-offer-file.component.html',
  styleUrls: ['./admin-offer-file.component.scss']
})
export class AdminOfferFileComponent implements OnInit {
  @Input() offerKey: number;

  @Output() editFinished = new EventEmitter<boolean>();

  files: any;

  filesItemDropped: FileHandle[] = [];
  loadingDocuments = true;
  loadingImages = true;

  imagesForSlideShow: any = [];
  documents: any = [];

  newDocuments: any = [];
  newImagesForSlideShow: any = [];
  listBoundDocuments = [];
  loadBoundFiles: boolean;
  userConnected: any;
  roleMSR = 'AdminMSR';
  roleAdmin = 'admin';
  roleCROS = 'AdminCROS';

  private extensionsAllowed = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'jfif'];
  private regExpExtension = /(?:\.([^.]+))?$/;
  private extensionsImage = ['jpg', 'jpeg', 'png', 'jfif'];
  private extensionsDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

  constructor(
    private offerFileService: OfferFileService,
    private offerService: OfferService,
    private route: ActivatedRoute,
    private uiService: UiService,
    private faIconService: FaiconService,
    private dialog: MatDialog,
    private dataService: DataService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.getFileUpload();
    this.getImagesSlideShow();
    this.getBoundDocuments();
  }

  back() {
    this.editFinished.next(true);
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  uploadFiles(files: any): void {
    const limitSize = 3000000;
    const limitSizeForImg = 500000;
    const filesArray = [...files];

    filesArray.forEach((f, i) => {
      const extension = this.regExpExtension.exec(f.name)[1];

      // if (f.type !== 'application/pdf' && f.type !== 'image/jpeg' && f.type !== 'image/png') {
      //   this.uiService.showSnackbar(`Le fichier:  ${f.name} - n'est pas un format valide`);
      // } else if (f.type === 'image/jpeg' || f.type === 'image/png' || f.type === 'image/jfif') {
      //   if (f.size > limitSizeForImg) {
      //     this.uiService.showSnackbar(`L'image:  ${f.name} est trop lourde (500kB max.)`);
      //   } else {
      //     this.newImagesForSlideShow.push(f)
      //   }
      // } else {
      //   if (f.size > limitSize) {
      //     this.uiService.showSnackbar(`Le fichier:  ${f.name} est trop lourd (3MB max.)`);
      //   } else {
      //     this.newDocuments.push(f)
      //   }
      // }

      if (!this.extensionsAllowed.includes(extension)) {
        this.uiService.showSnackbar(`Le fichier:  ${f.name} - n'est pas un format valide`);
      } else {
        if (this.extensionsImage.includes(extension)) {
          if (f.size > limitSizeForImg) {
            this.uiService.showSnackbar(`L'image:  ${f.name} est trop lourde (500kB max.)`);

          } else {
            this.newImagesForSlideShow.push(f)
          }
        }
        if (this.extensionsDocument.includes(extension)) {
          if (f.size > limitSize) {
            this.uiService.showSnackbar(`Le fichier:  ${f.name} est trop lourd (3MB max.)`);
          } else {
            this.newDocuments.push(f)
          }
        }
      }

      if (filesArray.length === i + 1) {
        if (this.newDocuments.length > 0) {
          this.uploadDocuments();
        }

        if (this.newImagesForSlideShow.length > 0) {
          this.uploadImages();
        }
      }
    });
  }

  uploadDocuments() {
    if (this.newDocuments.length > 0) {
      this.loadingDocuments = true;
      this.offerFileService.uploadFiles(this.offerKey, this.newDocuments).subscribe(results => {
        results.map(fileFromSrv => {
          this.documents.push(fileFromSrv);
        })
        this.newDocuments = [];
        this.loadingDocuments = false;
      })
    }
  }

  uploadImages() {
    if (this.newImagesForSlideShow.length > 0) {
      this.loadingImages = true;
      this.offerService.uploadImages(this.offerKey, this.newImagesForSlideShow).subscribe(results => {
        results.map(fileFromSrv => {
          this.imagesForSlideShow.push(fileFromSrv);
        })
        this.newImagesForSlideShow = [];
        this.loadingImages = false;
      })
    }
  }

  downloadFile(offerKey: number, offerFileKey: number, name: string): void {
    this.offerFileService.downloadFile(offerKey, offerFileKey).subscribe({
      next: (blob) => {

        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        anchor.href = data;
        anchor.download = name;
        anchor.click();

        setTimeout(() => window.URL.revokeObjectURL(data), 100);
      }
    });
  }

  deleteFile(offerKey: number, offerFileKey: number): void {

    const message = "Êtes-vous certain de supprimer ce fichier ?";
    const dialogRef = this.dialog.open(OpenDialogConfirmComponent, {
      data: { text: message },
      width: '30%'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.loadingDocuments = true;
          this.offerFileService.deleteFile(offerKey, offerFileKey).subscribe({
            next: () => {
              this.documents = this.documents.filter(doc => doc.offerFileKey !== offerFileKey)
              this.loadingDocuments = false;

            }
          });
        } else {
          this.loadingDocuments = false;
        }
      }
    })

  }

  deleteImage(offerPictureKey: number): void {

    const message = "Êtes-vous certain de supprimer cette image ?";
    const dialogRef = this.dialog.open(OpenDialogConfirmComponent, {
      data: { text: message },
      width: '30%'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.loadingImages = true;
          this.offerService.deleteAltPictureOffer(offerPictureKey).subscribe({
            next: () => {
              this.imagesForSlideShow = this.imagesForSlideShow.filter(img => img.offerPictureKey !== offerPictureKey)
              this.loadingImages = false;
            }
          });
        } else {
          this.loadingImages = false;
        }
      }
    })
  }

  createBoundFile(): void {
    const params = {
      disableClose: true,
      autoFocus: false,
      padding: '10px !important',
      data: {
        offerKey: this.offerKey
      }
    };
    const dialoRef = this.dialog.open(ExternalLinkFormComponent, params);
    dialoRef.afterClosed().subscribe(res => {
      if (res) {
        this.listBoundDocuments.push(res);
      }
    });
  }

  editBoundFile(doc: any): void {
    const params = {
      disableClose: true,
      autoFocus: false,
      data: {
        offerKey: this.offerKey,
        file: doc
      }
    };
    const dialoRef = this.dialog.open(ExternalLinkFormComponent, params);
    dialoRef.afterClosed().subscribe(res => {
      if (res) {
        const index = this.listBoundDocuments.findIndex(d => d.key === doc.key);
        this.listBoundDocuments[index] = res;
      }
    });
  }

  deleteBoundFiles(key: number): void {
    const message = "Êtes-vous certain de supprimer cette ligne ?";
    const dialogRef = this.dialog.open(OpenDialogConfirmComponent, {
      data: { text: message },
      width: '30%'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.offerService.deleteBoundDocument(key).subscribe({
            next: () => {
              this.listBoundDocuments = this.listBoundDocuments.filter(doc => doc.key !== key);
            }
          })
        }
      }
    })
  }

  private getFileUpload(): void {
    this.offerFileService.getFiles(this.offerKey).subscribe({
      next: files => {
        this.documents = files.result;
        this.loadingDocuments = false;
        document.getElementById('file').classList.remove('file_dropped');
      }
    });
  }

  private getImagesSlideShow(): void {
    this.offerService.getAltOfferPictures(this.offerKey).subscribe({
      next: files => {
        this.imagesForSlideShow = files;
        this.loadingImages = false;
        document.getElementById('file').classList.remove('file_dropped');
      }
    });
  }

  private getBoundDocuments(): void {
    this.loadBoundFiles = true;
    this.offerService.getBoundDocumentsByOfferKey(this.offerKey).subscribe({
      next: data => {
        this.loadBoundFiles = false;
        this.listBoundDocuments = data;
      },
      error: () => this.loadBoundFiles = false
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.dataService.tabActiveOfferEdit$.next('description');
  }
}
